<template lang="pug">
	b-navbar#nav.navContainer
		//- template(slot="brand")
		//- 	b-navbar-item(tag="router-link", :to="{ path: '/' }")
		//- 		img(src="https://raw.githubusercontent.com/buefy/buefy/dev/static/img/buefy-logo.png", alt="")
		template(slot="start")
			template(v-if="loggedIn")
				b-navbar-item(tag="router-link", :to="{ name: 'home' }") Log
				//- Link to Employees Screen (read:employees needed)
				b-navbar-item(tag="router-link", :to="{ name: 'edit-employees' }", v-if="userPermissions.indexOf('read:employees') > -1") Employees
		template(slot="end")
			//- If logged in: regular navbar
			template(v-if="loggedIn")
				.level: .level-right
					.level-item
						b-dropdown(position="is-bottom-left")
							b-navbar-item(slot="trigger", role="button")
								span Menu
								b-icon(icon="menu-down")
							b-dropdown-item(custom)
								span.is-unselectable Logged in as 
								strong.is-unselectable {{ user.email }}
							hr.dropdown-divider
							b-dropdown-item: router-link(tag="span", :to="{ name: 'edit-profile' }"): .level: .level-left
								.level-item: b-icon(icon="cog", pack="fas")
								.level-item: span Settings
							//- hr.dropdown-divider
							b-dropdown-item(@click="logout"): .level: .level-left
								.level-item: b-icon(icon="sign-out-alt", pack="fas")
								.level-item: span Logout
			//- If not logged in: show Login button
			template(v-else)
				b-navbar-item(tag="div")
					.buttons
						b-button(@click="login", type="is-dark", size="is-medium") Log in
</template>

<style lang="scss" scoped>
	#nav {
		padding: 1rem;
		.router-link-exact-active:not(.is-primary) {
			color: $primary;
		}

		// Fix dropdown styling against Buefy
		a.navbar-item:hover {
			background-color: initial;
		}
		.dropdown {
			a.dropdown-item {
				padding-right: 0;
			}

			.dropdown-item:focus {
				outline: 0;
			}
		}
	}
</style>

<script>
	import { mapState, mapGetters } from "vuex";

	export default {
		data() {
			return {};
		},
		computed: {
			...mapState(["user", "permissions"]),
			...mapGetters(["loggedIn"]),
			userPermissions() {
				// cannot use this.permissions directy because this component loads before the state
				return this.permissions ? this.permissions : [];
			}
		},
		methods: {
			// Login via Auth0
			login() {
				this.$auth.loginWithRedirect();
			},
			// Logout
			logout() {
				this.$store.dispatch("logout");
			}
		}
	};
</script>
